import FmdBadRoundedIcon from '@mui/icons-material/FmdBadRounded';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import ShipperDPDIcon from '../../svg-icons/ShipperDPDIcon';
import ShipperUPSIcon from '../../svg-icons/ShipperUPSIcon';
import ErrorBoundary from '../errors/ErrorBoundary';
import InternalServerError from '../errors/InternalServerError.jsx';

const selectShipperIcon = (shipper, size) => {
  switch (shipper) {
    case 'DPD':
      return <ShipperDPDIcon sx={{ fontSize: size }} />;
    case 'UPS':
      return <ShipperUPSIcon sx={{ fontSize: size }} />;
    default:
      return <FmdBadRoundedIcon />;
  }
};

const ShipperIcon = (props) => {
  const { shipper, size = 32 } = props;

  return (
    <ErrorBoundary fallback={<InternalServerError />} source="ShipperIcon">
      <Tooltip placement="top" title={`${shipper}`}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          {shipper ? selectShipperIcon(shipper, size) : null}
        </Box>
      </Tooltip>
    </ErrorBoundary>
  );
};

export default ShipperIcon;
